import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["container"]

  connect() {
    this.load()
  }

  async load() {
    try {
      const token = document.querySelector("meta[name=csrf-token]")?.content
      const response = await fetch(this.urlValue, {
        headers: { "X-CSRF-Token": token, "Accept": "text/html" }
      })
      if (!response.ok) return

      const html = await response.text()
      if (html.trim()) this.containerTarget.innerHTML = html
      else this.containerTarget.remove()
    } catch {
      this.containerTarget.remove()
    }
  }
}
